<template>
  <div>
    <gmap-map
      ref="mapRef"
      :center="center"
      :zoom="11.1"
      style="width:100%;  height: 560px;">
      <gmap-cluster
        :minimumClusterSize="10" 
        :zoomOnClick="true" 
        :styles="clusterStyles">
        <gmap-marker
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          @click="toggleInfoWindow(m,index)">
        </gmap-marker>
        </gmap-cluster>
        <gmap-info-window
          :options="infoOptions"
          :position="infoWindowPos"
          :opened="infoWinOpen"
          @closeclick="infoWinOpen=false">
          <div v-html="infoContent" @click="setInfoPopUpCloseButton()"></div>
        </gmap-info-window>
    </gmap-map>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import { ContentService } from "@/service/content.service";
// How to impot this
// @import '~bulma/sass/utilities/mixins';
// @import '~bulma/sass/utilities/mixins';

function getCircle(color, size) {
  const radius = size / 2;
  const encoded = window.btoa('<svg height="'+size+'" width="' + size + '" xmlns="http://www.w3.org/2000/svg"><circle r="' + radius + '" cx="'+ radius + '" cy="' +radius + '" fill="' + color + '" /></svg>');

  return ('data:image/svg+xml;base64,' + encoded);
}

const clusterCircleUrl = getCircle('#ED4432', 40);

export default {
  //TODO: move filter logic into the locations.vue folder. 
  //this will remove need to duplicate error message code.

  name: "GoogleMap",
  props: ["mapData", "updatedData", "mapLocations", "center"],
  watch: {
    updatedData: function() {
      this.addMarker();
    },
  },
  data() {
    return {
      locationsContent: {},
      map: null,
      // default to Detriot to keep it simple
      // change this to whatever makes sense
      markers: [],
      places: [],
      currentPlace: [],
      locationsAll: [],
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoWinOpen: false,
      currentMidx: null,
      //optional: offset infowindow so it visually sits nicely on top of our marker
      infoOptions: {
        minWidth: 320,
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      clusterStyles: [
        {
            width: 40,
            height: 40,
            url: clusterCircleUrl,
            textColor: 'black',
            textSize: 14
        },
        {
            width: 40,
            height: 40,
            url: clusterCircleUrl,
            textColor: 'black',
            textSize: 14,

        },
        {
            width: 40,
            height: 40,
            url: clusterCircleUrl,
            textColor: 'black',
            textSize: 14
        }
        //up to 5
    ]
    };
  },

  mounted: async function() {
    await this.addMarker()
    const contentService = new ContentService(this.$route)
    this.locationsContent = await contentService.getLocationsContent();
    this.$refs?.mapRef?.$mapPromise?.then( map => this.map = map);
  },

  methods: {
    // receives a place object via the autocomplete component
    setPlace(place) {
      this.currentPlace = place;
    },

    toggleInfoWindow: function(marker, idx) {
      this.infoWindowPos = marker.position;
      // If on mobile then define a pan postion
      // This position is used to auto scroll the window 
      // to prevent overlap with the filter button
      if (typeof window.orientation !== 'undefined') { 
        this.mobilePadding = '45px';
        const panPosition = {
         lat: this.infoWindowPos.lat + 0.0655,
         lng: this.infoWindowPos.lng
        }

        this.map.panTo(panPosition);
       }

      this.infoContent = this.getInfoWindowContent(marker, this.mapData.client);

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
      if(this.infoWinOpen){
          this.setInfoBorder(this.mapData.client);
        }

    },
    
    // In order to change the styling of the info window
    // we have to wait window to exist and then modify the css.
    // This function will loop up to 100 times waiting for existence.
    // After info window is found it modifies styling.
    setInfoBorder: function (client) {
      setTimeout(function () {
        const iwOuter = document.getElementsByClassName("gm-style-iw")[0];
        const closeButton = iwOuter.getElementsByTagName("button")[0];
        const iwOuterD = document.getElementsByClassName("gm-style-iw-d")[0];
        const closeButtonImg = closeButton.getElementsByTagName("img")[0];
        iwOuter.style.padding = 0;
        iwOuterD.style.overflow = "";
        closeButton.classList.add("fas");
        closeButton.classList.add("close-button-padding");
        closeButton.classList.remove("gm-ui-hover-effect");

        if(client === 'isDHS'){
          closeButton.classList.add("card-color-white");
          closeButton.classList.add("fa-times-thin");
        }
        else{
          closeButton.classList.add("card-color-yellow");
          closeButton.classList.add("fa-times");
        }
        if (closeButtonImg) {
          closeButtonImg.parentNode.removeChild(closeButtonImg);
        }
      }, 0);
    },

    showErrorMessage(titleMessage, bodyMessage) {
      Swal.fire({
        html: '<p><b>' + titleMessage + '</b></P>' + '<p>' + bodyMessage + '</p>',
      })
    },

    // Add google map marker
    addMarker: async function() {
      let locations = await this.mapLocations;
      locations = this.filterLocationType(
        locations,
        this.mapData.filters
      );

      locations = this.filterLocationRating(
        locations,
        this.mapData.publishedrating
      );

      if(!locations || locations.length === 0){
        this.showErrorMessage('No locations were found with the given filter selections.', 'Please adjust filter selections and try again.');
      }
      this.markers = this.getMarkerDetails(locations);
    },

    /**
     * Filter Locations based on rating. 
     */
    filterLocationRating: function(locationsGiven, starRating) {
      if (!locationsGiven?.length || !starRating) {
        return locationsGiven;
      }

      /* eslint-disable no-debugger, no-console */
      //console.log( 'filtered by startRating =>', starRating )

      const filteredLocations = locationsGiven.filter(
        locale => locale.publishedrating >= parseInt(starRating)
      );

      return filteredLocations;
    },

    /**
     * Filter locations based on location type/service provided.
     */
    filterLocationType: function(locationsGiven, filtersGiven) {
      if (!locationsGiven?.length || !filtersGiven?.length) {
        return locationsGiven;
      }

      /* eslint-disable no-debugger, no-console */
      //console.log( 'filtered by filtersGiver =>', JSON.stringify(filtersGiven) )
      
      const filteredLocations = locationsGiven.filter(function (locale) {
        for (const index in filtersGiven) {
          /* eslint-disable no-debugger, no-console */
          //console.log( 'filtered by filtersGiven keyName =>', locale[filtersGiven[index].keyName] )
          //console.log( 'filtered by filtersGiven activeValue =>', filtersGiven[index].activeValue)

          if(locale[filtersGiven[index].keyName] == filtersGiven[index].activeValue) {
            return true;
          }
        }
      })

      return filteredLocations;
    },

    /**
     * Get Marker details to be populated in the marker pop up window.
     */
    getMarkerDetails: function(locationsFiltered) {
      const markers = [];

      const QualityLevel = this.locationsContent.QualityLevel ?? "Quality Level";
      const QualityLevelUndefined = this.locationsContent.QualityLevelUndefined ?? "Quality Level Undefined";
      
      for (let i = 0; i < locationsFiltered?.length; i++) {
        let publishedRating = QualityLevelUndefined;
        if(locationsFiltered[i].publishedrating != null) {
          publishedRating = `${QualityLevel} ${locationsFiltered[i].publishedrating}`;
        }

        const marker = {
          businessname: locationsFiltered[i].businessname,
          phone: locationsFiltered[i].phone,
          greatstart: locationsFiltered[i].greatstart,
          earlyheadstart: locationsFiltered[i].earlyheadstart,
          headstart: locationsFiltered[i].headstart,
          cdcsubsidy: locationsFiltered[i].cdcsubsidy,
          address: locationsFiltered[i].address,
          city: locationsFiltered[i].city,
          state: locationsFiltered[i].state,
          zip: locationsFiltered[i].zip,
          contactname: locationsFiltered[i].contactname,
          publishedrating: publishedRating,
          licensetype: locationsFiltered[i].licensetype,
          website: locationsFiltered[i].website,
          position: {
            lat: locationsFiltered[i].latitude,
            lng: locationsFiltered[i].longitude
          }
        };
        markers.push(marker);
      }
      return markers;
    },

    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },

    displayTypeChecks: function(marker, type) {
      const descritionline2 = type.descriptionLine2 ? ' ' + type.descriptionLine2 : ''
      const description = type.descriptionLine1 + descritionline2;
      if(marker[type.keyValue.keyName] == type.keyValue.activeValue){
        return `<i class="fas card-color-blue fa-check is-inline"></i>
                <h1 class="card-color-blue is-size-7 is-inline card-padding-left-3">${description}</h1>
                <span class="icon has-text-info is-small">
                      <i class="fas fa-question-circle is-small" title="${type.tooltip}" onclick="onMapClick('${type.modalInfoHeader}','${type.modalInfoBody}','${type.learnMoreLink}')"></i>
                </span>
                `;
      }
      else {
        return `<i class="fas card-color-light-blue fa-times is-inline"></i>
                <h1 class="card-color-light-blue is-size-7 is-inline card-padding-left-3">${description}</h1>
                <span class="icon has-text-info is-small">
                      <i class="fas fa-question-circle is-small" title="${type.tooltip}" onclick="onMapClick('${type.modalInfoHeader}','${type.modalInfoBody}','${type.learnMoreLink}')"></i>
                </span>
                `;
      }
    },
    setInfoPopUpCloseButton: function () {
      //Set timeout to delay function just enough for the info pop up to load.
      setTimeout(function () {
        const infoPopUp = document.getElementsByClassName("swal2-header")[0];
        if(infoPopUp){
          const closeButton = infoPopUp.getElementsByTagName("button")[0];
          closeButton.setAttribute("style", "color:rgb(255, 175, 0);font-size: 1.5em");
        }
      }, 0);
    },
    displayWebSite: function(website, client) {
      if(website) {
        if(client === 'isDHS'){
          return `<p><a class="card-item card-button-link-isDHS text-size-1-2" target="_blank" href="//${website}">${website}</a></p>`
        }
        else{
          return `<p><a class="card-item card-button-link text-size-1-2" target="_blank" href="//${website}">${website}</a></p>`
        }
      }
      else {
       return ``;
      }
    },

    getInfoWindowContent: function(marker, client) {
      if(client === 'isDHS'){
        return `
          <div class="card is-marginless mobile-padding">
            <h1 class="card-title isDHS-color font-isDHS has-text-black text-size-1-2">${marker.businessname}</h1>
            <div class="card-padding-bottom-10">
              <h1 class="card-item has-text-black text-size-1-2 card-padding-top-8">${marker.phone}</h1>
              ${this.displayWebSite(marker.website, client)}
              <h1 class="card-sub-item has-text-black is-size-7">${marker.address} ${marker.city}, ${marker.state} ${marker.zip}</h1>
              <div>
                <h1 class="card-sub-item is-inline has-text-black is-size-7 card-padding-botton-8">${marker.licensetype}</h1>
                <span class="has-text-info">
            </div>
          </div>`;
      }
      else {
        return `
          <div class="card is-marginless mobile-padding">
              <h1 class="card-title default-blue has-text-weight-bold has-text-white text-size-1-2">${marker.businessname}</h1>
              <h1 class="card-item has-text-black text-size-1-2 card-padding-top-8">${marker.phone}</h1>
              ${this.displayWebSite(marker.website, client)}
              <h1 class="card-sub-item has-text-black is-size-7">${marker.address} ${marker.city}, ${marker.state} ${marker.zip}</h1>
              <div>
                <h1 class="card-sub-item is-inline has-text-black is-size-7">${marker.licensetype} | ${marker.publishedrating}</h1>
                <span class="has-text-info">
                  <i class="fas fa-question-circle" title="${this.locationsContent.starRating.tooltip}" onclick="onMapClick('${this.locationsContent.starRating.modalInfoHeader}','${this.locationsContent.starRating.modalInfoBody}','${this.locationsContent.starRating.learnMoreLink}')"></i>
                </span>
              </div>
              <h1 class="card-sub-item has-text-black is-size-7 is-inline">${this.locationsContent.ContactLocation}</h1>
              <div class="card-check-box card-padding-bottom-10">
                <div>
                  ${this.displayTypeChecks(marker, this.locationsContent.headStart)}
                  <div class="card-padding-left-10 is-inline"></div>
                  ${this.displayTypeChecks(marker, this.locationsContent.earlyHeadStart)}
                </div>
                <div>
                  ${this.displayTypeChecks(marker, this.locationsContent.greatStart)}
                </div>
                ${this.displayTypeChecks(marker, this.locationsContent.miChildDev)}
              </div>
          </div>`;
      }
      
    }
  }
};
</script>

<style lang="scss">

// .mobile-padding {
//   @include mobile {
//     padding-bottom: var(--mobilePadding);
//   }
// }

.card-button-link {
  &:hover {
    text-decoration: underline;
    text-decoration-color: #3273dc;
    color: #3273dc;
  }
  &:focus {
    text-decoration: underline;
    text-decoration-color: #3273dc;
    color: #3273dc;
  }
}
.card-button-link-isDHS {
  color: #862699;
  &:hover {
    text-decoration: underline;
    text-decoration-color: #862699;
    color: #862699;
  }
  &:focus {
    text-decoration: underline;
    text-decoration-color: #862699;
    color: #862699;
  }
}
.fa-times-thin:before {
	content: '\00d7';
}
.text-size-1-2 {
  font-size: 1.2rem;
}
.card-color-blue {
  color: #0033A0;
}

.card-color-yellow {
  color: #ffaf00;
}
.card-color-white {
  color: white;
}
.card-color-light-blue {
  color: #7BA4DB;
}
.default-blue {
  background-color: #0033A0;
}
.isDHS-color {
  background-color: #52BDDF;
}
.font-isDHS {
  font-family: 'Fredoka One' !important;
  font-size: 19px;
}
.card-title {
  display: flex;
  flex-wrap: wrap;
  text-align: left;
  padding-top: 15px;
  padding-bottom: 10px;
  padding-right: 15px;
  padding-left: 17px;
}
.card-check-box {
  padding-top: 12px;
  padding-left: 17px;
}
.card-padding-top-5 {
  padding-top: 5px;
}
.card-padding-top-8 {
  padding-top: 8px;
}
.card-padding-botton-8 {
  padding-bottom: 8px;
  margin-bottom: 8px;
}
.card-check-text {
  text-align: left;
  font-weight: 300;
  font-size: 10px;
  color: #0033A0;
  font-family: 'Avenir Next';
}
.card-padding-left-3 {
  padding-left: 3px;
}
.card-padding-left-10 {
  padding-left: 10px;
}

.card-padding-bottom-10 {
  padding-bottom: 10px;
}
.card-sub-item {
  text-align: left;
  padding-left: 17px;
  font-weight: 300;
  font-size: 10px;
  font-family: 'Avenir Next';
}
.card-item {
  text-align: left;
  padding-left: 17px;
}

.close-button-padding {
  padding-top: 4px !important;
  padding-right: 4px !important;
  width: 30px !important;
  height: 20px !important;
}

</style>